import React, { useEffect, useRef } from 'react';

const AdSlot = ({ divId, unitPath, sizes, mappingConfig }) => {
  const adSlotRef = useRef(null);
  const eventListenerRef = useRef(null);

  useEffect(() => {
    if (!sizes?.[0]?.[0] || !sizes?.[0]?.[1]) {
      console.warn('AdSlot: Invalid sizes array', sizes);
      return;
    }

    const defineAndDisplay = () => {
      const googletag = window.googletag;
      if (!googletag) {
        console.warn('GoogleTag not loaded');
        return;
      }

      googletag.cmd.push(() => {
        // Create new slot
        const slot = googletag.defineSlot(unitPath, sizes, divId);
        if (!slot) return;
        slot.addService(googletag.pubads());

        if (mappingConfig?.length) {
          const mapping = googletag.sizeMapping();
          mappingConfig.forEach(conf => {
            mapping.addSize(conf.viewport, conf.slotSizes);
          });
          slot.defineSizeMapping(mapping.build());
        }

        adSlotRef.current = slot;
        googletag.display(divId);
      });
    }

    let interval = null;
    if (window.googletag && window.googletag.apiReady) {
      defineAndDisplay();
    } else {
      // On user's first accept, wait for GPT to finish loading
      interval = setInterval(() => {
        if (window.googletag && window.googletag.apiReady) {
          clearInterval(interval);
          defineAndDisplay();
        }
      }, 100);
    }

    return () => {
      if (interval) clearInterval(interval)
      window.googletag.cmd.push(() => {
        if (adSlotRef.current) {
          window.googletag.destroySlots([adSlotRef.current]);
          adSlotRef.current = null;
        }
      });
    };
  }, [divId, unitPath, sizes, mappingConfig]);

  return (
    <div
      id={divId}
      className="ad-slot"
    />
  );
};

export default AdSlot;